"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceElevator = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class SpaceElevator extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SPACE_ELEVATOR,
            tags: [Tags_1.Tags.SPACE, Tags_1.Tags.BUILDING],
            cost: 27,
            productionBox: Units_1.Units.of({ titanium: 1 }),
            metadata: {
                cardNumber: '013',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 1 steel to gain 5 M€.', (eb) => {
                        eb.steel(1).startAction.megacredits(5);
                    }).br;
                    b.production((pb) => pb.titanium(1));
                }),
                description: 'Increase your titanium production 1 step.',
                victoryPoints: 2,
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        return undefined;
    }
    canAct(player) {
        return player.steel > 0;
    }
    action(player) {
        player.steel--;
        player.megaCredits += 5;
        return undefined;
    }
    getVictoryPoints() {
        return 2;
    }
}
exports.SpaceElevator = SpaceElevator;
//# sourceMappingURL=SpaceElevator.js.map